import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/styles';

const CustomizedCircularProgress = withStyles(() => ({
  colorPrimary: {
    color: 'var(--color-main-orange)',
  },
}))(CircularProgress);

const styles = {
  normal: { display: 'flex', flexDirection: 'row', justifyContent: 'center' },
  wholePage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
};

export default function LoadingBar({ wholePage }) {
  return (
    <div style={wholePage ? styles.wholePage : styles.normal}>
      <CustomizedCircularProgress />
    </div>
  );
}
